/**
 * The site's viewer token (docs: /viewer-tokens), passed after # so it never
 * reaches a server or a log: `#vt=<jwt>`. Read once at load and removed from
 * the address (other fragment parts, such as a moderator link, stay). Kept
 * for this tab only (sessionStorage), so a channel page that reloads for its
 * next stream still has it, until the token's own exp.
 */
const JWT = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

function exp(token: string): number {
  try {
    const p = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))) as { exp?: unknown };
    return typeof p.exp === 'number' ? p.exp : 0;
  } catch {
    return 0;
  }
}

export function takeViewerToken(pageId = ''): string | null {
  const key = `jc.vt.${pageId}`;
  const hash = location.hash.replace(/^#/, '');
  const parts = hash ? hash.split('&') : [];
  const vt = parts.find((p) => p.startsWith('vt='));
  if (vt) {
    const rest = parts.filter((p) => p !== vt).join('&');
    history.replaceState(null, '', location.pathname + location.search + (rest ? `#${rest}` : ''));
    const token = decodeURIComponent(vt.slice(3));
    if (!JWT.test(token)) return null;
    try {
      sessionStorage.setItem(key, token);
    } catch {
      /* this load only */
    }
    return token;
  }
  try {
    const kept = sessionStorage.getItem(key);
    if (kept && exp(kept) * 1000 > Date.now()) return kept;
  } catch {
    /* none */
  }
  return null;
}
